export const TOKEN = 'auth:token';

export const LOTES_STORAGE = {
  createFrom: 'lotes:create-from',
  createBefore: 'lotes:create-before',
  prefixo: 'lotes:prefixo',
  page: 'lotes:page',
  sort: 'lotes:sort',
  search: 'lotes:search',
  textofiltro: 'lotes:textofiltro',

};

export const PRODUCAO_STORAGE = {
  createFrom: 'producao:create-from',
  createBefore: 'producao:create-before',
  page: 'producao:page',
  sort: 'producao:sort',
  search: 'producao:search',

};

export const CONSULTA_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
};

export const CADASTRO_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
};

export const MODULOS_STORAGE = {
  modulos: 'permitidos',
};

export const USER_STORAGE = {
  userId: 'id-usuario',
  trocasenha: 'troca-senha',
  instrucoes: 'troca-senha-instrucoes',
};

export const A_PAGAR_STORAGE = {
  createFrom: 'apagar:create-from',
  createBefore: 'apagar:create-before',
  parametro: 'apagar:parametro',
  page: 'apagar:page',
  sort: 'apagar:sort',
  search: 'apagar:search',
  textofiltro: 'apagar:textofiltro',
};

export const A_RECEBER_STORAGE = {
  createFrom: 'areceber:create-from',
  createBefore: 'areceber:create-before',
  parametro: 'areceber:parametro',
  page: 'areceber:page',
  sort: 'areceber:sort',
  search: 'areceber:search',
  textofiltro: 'areceber:textofiltro',
};

export const FLUXO_DE_CAIXA_STORAGE = {
  createFrom: 'areceber:create-from',
  createBefore: 'areceber:create-before',
  page: 'areceber:page',
  sort: 'areceber:sort',
  search: 'areceber:search',
};

export const VENDAS_STORAGE = {
  createFrom: 'vendas:create-from',
  createBefore: 'vendas:create-before',
  parametro: 'vendas:parametro',
  page: 'vendas:page',
  sort: 'vendas:sort',
  search: 'vendas:search',
  textofiltro: 'vendas:textofiltro',
};

export const BALANCO_STORAGE = {
  idbalanco: 'id-balanco',
};

export const FILA_STORAGE = {
  statusFila: 'status-fila',
  tipoFila: 'tipo-fila',
  interval: 'interval',
};

export const CONDICIONAL_STORAGE = {
  createFrom: 'condicional:create-from',
  createBefore: 'condicional:create-before',
  parametro: 'condicional:parametro',
  page: 'condicional:page',
  sort: 'condicional:sort',
  search: 'condicional:search',
  textofiltro: 'condicional:textofiltro',
};

export const PEDIDO_VENDAS_STORAGE = {
  createFrom: 'pedidovendas:create-from',
  createBefore: 'pedidovendas:create-before',
  parametro: 'pedidovendas:parametro',
  page: 'pedidovendas:page',
  sort: 'pedidovendas:sort',
  search: 'pedidovendas:search',
  textofiltro: 'pedidovendas:textofiltro',
};

export const ORDEM_SERVICO_STORAGE = {
  createFrom: 'ordemservico:create-from',
  createBefore: 'ordemservico:create-before',
  parametro: 'ordemservico:parametro',
  page: 'ordemservico:page',
  sort: 'ordemservico:sort',
  search: 'ordemservico:search',
  textofiltro: 'ordemservico:textofiltro',
};

export const TURNO_CAIXA_STORAGE = {
  createFrom: 'turnocaixa:create-from',
  createBefore: 'turnocaixa:create-before',
  parametro: 'turnocaixa:parametro',
  page: 'turnocaixa:page',
  sort: 'turnocaixa:sort',
  search: 'turnocaixa:search',
  textofiltro: 'turnocaixa:textofiltro',
  aba: 'turnocaixa:aba',
};

export const MOVIMENTO_CAIXA_STORAGE = TURNO_CAIXA_STORAGE;
